import {
  ASSIGN_TIP,
  CANCEL_TIPPING,
  NEXT_TIPPING_BARBER,
  PREVIOUS_TIPPING_BARBER,
  RESET_TIPPING_BARBERS,
  SET_ADJUSTMENTS,
  SET_PROCESSING,
  SET_TIPPING_BARBERS,
  TIPPING_DONE,
} from './constants';

export const resetTippingBarbers = () => ({
  type: RESET_TIPPING_BARBERS,
});

export const setTippingBarbers = barbers => ({
  type: SET_TIPPING_BARBERS,
  payload: barbers,
});

export const previousTippingBarber = () => ({
  type: PREVIOUS_TIPPING_BARBER,
});

export const nextTippingBarber = () => ({
  type: NEXT_TIPPING_BARBER,
});

export const assignTip = (barberId, firstName, paymentId, amount, type) => ({
  type: ASSIGN_TIP,
  payload: { barberId, firstName, paymentId, amount, type },
});

export const tippingDone = payload => ({ type: TIPPING_DONE, payload });

export const cancelTipping = () => ({ type: CANCEL_TIPPING });

export const setProcessing = payload => ({ type: SET_PROCESSING, payload });

export const setAdjustments = payload => ({ type: SET_ADJUSTMENTS, payload });
